import React from "react";
import "./Education.css";
import Navbar from "../components/Navbar";

const LearningAndInnovation = () => {
  return (
    <>
      <Navbar />
      <div className="energyInfra-container">
        <div className="energyInfra-content">
          {/* Corporate Learning & Innovation Section */}
          <p className="para">Industries / Corporate Learning & Innovation</p>
          <h2>Corporate Learning & Innovation</h2>
          <p className="subtitle1">
            Accelerating Enterprise Upskilling & R&D through Immersive Technologies
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we help enterprises foster a culture of continuous learning and innovation by integrating XR (Extended Reality) into workforce development, L&D programs, and R&D operations. Our spatial solutions enhance knowledge retention, engagement, and innovation velocity — driving real, measurable impact.
          </p>

          {/* Solutions We Offer */}
          <div className="energyInfra-grid">
            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Immersive Corporate Training Modules</h4>
                <p>Transform legacy e-learning into interactive XR-based training.</p>
                <ul>
                  <li>Scenario-based learning: sales, onboarding, compliance, equipment handling</li>
                  <li>Soft-skills training: negotiation, DEI, public speaking in VR</li>
                  <li>Performance metrics and knowledge assessments built-in</li>
                </ul>
                <p><strong>Ideal for:</strong> L&D teams, HR departments, enterprise training academies</p>
              </div>

              <div className="energyInfra-box">
                <h4>Enterprise Innovation Labs</h4>
                <p>Set up XR-powered labs to ideate, experiment, and develop future-ready solutions.</p>
                <ul>
                  <li>Co-create proofs-of-concept with internal teams</li>
                  <li>R&D sandboxes for AI + XR product development</li>
                  <li>Cross-functional collaboration across departments</li>
                </ul>
                <p><strong>Ideal for:</strong> Corporate strategy teams, CTO offices, intrapreneurship cells</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Design Thinking & Problem Solving in XR</h4>
                <p>Use spatial interfaces to enhance brainstorming, ideation, and rapid prototyping.</p>
                <ul>
                  <li>3D whiteboarding, post-it mapping, journey simulations in XR</li>
                  <li>Virtual co-location of remote teams</li>
                  <li>Integrated design thinking toolkits and templates</li>
                </ul>
                <p><strong>Ideal for:</strong> Product managers, design teams, innovation heads</p>
              </div>

              <div className="energyInfra-box">
                <h4>XR Dashboards & Decision Rooms</h4>
                <p>Visualize enterprise data in 3D spatial interfaces for better strategic decisions.</p>
                <ul>
                  <li>Live KPI dashboards in VR/AR</li>
                  <li>Interactive control panels and what-if simulations</li>
                  <li>Use with AI copilots for smarter meetings</li>
                </ul>
                <p><strong>Ideal for:</strong> CXOs, operations teams, corporate strategy units</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Global Workforce Collaboration & Onboarding</h4>
                <p>Faster onboarding and smoother collaboration for distributed teams.</p>
                <ul>
                  <li>Virtual onboarding campuses and meet-your-team in VR</li>
                  <li>Shared spatial environments for onboarding tours and process walkthroughs</li>
                  <li>Language support and local customization</li>
                </ul>
                <p><strong>Ideal for:</strong> MNCs, global HR teams, remote-first companies</p>
              </div>
            </div>
          </div>

          {/* Use Cases Table for Corporate Learning */}
          <div className="usecases1-section">
            <h3>Use Cases At a Glance</h3>
            <div className="usecases1-table">
              <div className="usecases1-row usecases1-header">
                <div>Use Case</div>
                <div>Application</div>
                <div>Benefit</div>
              </div>
              <div className="usecases1-row">
                <div>XR Training</div>
                <div>Compliance, onboarding</div>
                <div>Higher engagement, retention</div>
              </div>
              <div className="usecases1-row">
                <div>Innovation Labs</div>
                <div>R&D, Co-creation</div>
                <div>Faster ideation, prototyping</div>
              </div>
              <div className="usecases1-row">
                <div>VR Soft Skills</div>
                <div>Leadership, HR</div>
                <div>Scalable behavioural training</div>
              </div>
              <div className="usecases1-row">
                <div>XR Dashboards</div>
                <div>Strategic meetings</div>
                <div>Better insights, decisions</div>
              </div>
              <div className="usecases1-row">
                <div>Virtual Collaboration</div>
                <div>Remote teams</div>
                <div>Unified team experience</div>
              </div>
            </div>

            <div className="usecases1-cta">
              <h4>Partner with Us</h4>
              <p>
                Let’s design the next era of enterprise learning and innovation together. Whether you need a single immersive module or a full-fledged innovation lab, SpatialCT delivers spatial-first solutions tailored for impact.
              </p>
              <p>
                <b>Contact us</b> to explore how immersive technologies can transform your workforce and innovation culture.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LearningAndInnovation;
